import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles(() => ({
  quantityCell: {
    display: "grid",
    gridTemplateColumns: "22px auto 22px",
    alignItems: "center",
    justifyContent: "center",
    columnGap: "4px",
    width: "100%"
  },
  undoSlot: {
    width: "22px",
    height: "22px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center"
  },
  quantityInput: {
    "& .MuiOutlinedInput-input": {
      padding: "6px",
      width: "72px",
      textAlign: "right"
    }
  }
}));
